module.exports = __webpack_public_path__ + "static/ohp_menu-0b7690aa27c5ab0cf74827dbcdbf43ba.png";